import React from 'react';
import { cn } from '@bem-react/classname';
import style from './Toast.module.scss';

type Props = {
  heading: string;
  message: string;
};
const Toast = (props: Props) => {
  const cName = cn(style.cToast);

  return (
    <div className={cName()}>
      <h3 className={cName('Heading')}>{props.heading}</h3>
      <div className={cName('Message')}>{props.message}</div>
    </div>
  );
};

export default Toast;
